<template>
  <div class="mobile-home mobile" v-loading="loading">
    <el-backtop></el-backtop>
    <div class="mobile-home-search">
      <el-input v-model="keyword" @keyup.enter.native="search()" :placeholder="plaKey">
        <el-button slot="append" @click="search()">搜索</el-button>
      </el-input>
    </div>
    <div class="mobile-home-hot">
      <el-divider content-position="left">热门方向</el-divider>
      <div class="hot-echart">
        <wordcloud-Chart
          style="-webkit-filter: saturate(0.5);filter: saturate(0.5);"
          :WordCloudList="hotData"
          id="CNChart"
          height="100%"
          width="100%"
          tit
          :isClick="true"
        />
      </div>
    </div>
    <div class="mobile-home-experts" v-if="experts.length">
      <div class="home-expert" v-for="(item,index) in experts" :key="index" >
        <el-row :gutter="20" type="flex">
          <el-col :span="10">
            <router-link
              :to="{path:'/Mobile/Detail',query: /^\d+$/.test(item.kId)? {kId:item.kId } :{name:item.name,institute:item.organization}}"
            >
              <el-image
                lazy
                class="exp-header"
                :src="item.avatarUrl?'/old/public'+item.avatarUrl:'http://expert.ckcest.cn/autoload/images/avatar.png'"
                fit="contain"
              >
                <div slot="placeholder" class="image-slot">
                  <img src="http://expert.ckcest.cn/autoload/images/avatar.png" />
                </div>
                <div slot="error" class="image-slot">
                  <img src="http://expert.ckcest.cn/autoload/images/avatar.png" />
                </div>
              </el-image>
            </router-link>
          </el-col>
          <el-col :span="14" class="home-expert-info">
            <p>{{item.name}}</p>
            <p class="expert-info-org">{{item.organization}}</p>
            <p>
              <i class="el-icon-circle-check" /> 已认领
            </p>
            <p v-if="item.isni">ISNI {{item.isni}}</p>
            <p>学科 {{item.subject}}</p>
          </el-col>
        </el-row>
        <div class="home-expert-keyword" v-if="item.keyword">
          <el-tag
            type="success"
            v-for="key in item.keyword.split(';').slice(0, 4)"
            :key="key"
          >{{key}}</el-tag>
        </div>
        <div class="home-expert-resource">
          <div class="expert-resource" v-for="items in item.resource" :key="items.value">
            <img src="static/img/icon/papers.png" v-if="items.name === '期刊论文'" />
            <img src="static/img/icon/project.png" v-else-if="items.name === '项目成果'" />
            <img src="static/img/icon/patent.png" v-else-if="items.name === '专利'" />
            <img src="static/img/icon/books.png" v-else-if="items.name === '图书'" />
            <img src="static/img/icon/sci.png" v-else-if="items.name === 'SCI论文'" />
            <img src="static/img/icon/reward.png" v-else-if="items.name === '成果奖励'" />
            <img src="static/img/icon/EI.png" v-else-if="items.name === 'EI论文'" />
            <img src="static/img/icon/reward.png" v-else-if="items.name === '成果奖励'" />
            <img src="static/img/icon/other.png" v-else />
            <div>
              <span>{{items.count}}</span>
              <p>{{items.name}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
      <div v-else v-loading="true" style="min-height:200px"></div>

  </div>
</template>

<script>
import WordcloudChart from "@/components/Charts/WordcloudChart";
import { getRec, getRecExpert } from "@/api/home";
let hot = [
  { name: "信息技术", count: 1 },
  { name: "冠状病毒", count: 1 },
  { name: "高血压", count: 1 },
  { name: "深度学习", count: 1 },
  { name: "物联网", count: 1 },
  { name: "云计算", count: 1 },
  { name: "遗传算法", count: 1 },
  { name: "价格指数", count: 1 },
  { name: "数值模拟", count: 1 },
  { name: "数据挖掘", count: 1 },
  { name: "共享经济", count: 1 },
  { name: "农业", count: 1 },
  { name: "力学性能", count: 1 },
  { name: "深度学习", count: 1 },
  { name: "电动汽车", count: 1 },
  { name: "物理", count: 1 },
  { name: "机器人", count: 1 },
  { name: "智能制造", count: 1 },
  { name: "能源", count: 1 },
  { name: "中草药", count: 1 },
  { name: "金属材料", count: 1 }
];
export default {
  name: "Home",
  data() {
    return {
      plaKey: "",
      keyword: "",
      hotData: hot,
      experts: [],
      loading: false
    };
  },
  methods: {
    search() {
      if (!this.keyword) {
        this.keyword = this.plaKey;
      }
      this.$router.push({ name: "mSearch", query: { key: this.keyword } });
    },
    getExpert(data) {
      getRecExpert({ kId: data }).then(res => {
        let temp = res.data[0];
        temp.resource = res.resource;
        this.experts.push(temp);
      });
    }
  },
  mounted() {
    var randomNum4 = Math.ceil(Math.random() * 20);
    this.plaKey = hot[randomNum4].name;
    this.loading = true;
    getRec().then(res => {
      res.data.expert.forEach(element => {
        this.getExpert(element.key);
      });
    });
    this.$nextTick(()=>{
      this.loading = false;
    })
  },
  components: {
    WordcloudChart
  }
};
</script>

<style lang="scss">
.mobile-home {
  background: #fff;
  .mobile-home-search {
    margin: 20px 0;
  }
  .mobile-home-hot {
    padding: 10px 0 0 0;
    margin: 10px 0;
    margin-top: 5%;
    .hot-echart {
      height: 300px;
      border: 1px solid #dcdfe6;
      border-top: none;
    }
  }
  .mobile-home-experts {
    margin: 20px 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .home-expert {
      margin-top: 20px;
      img {
        max-width: 100%;
      }
      p {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .home-expert-info {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .expert-info-org {
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          -webkit-box-orient: vertical;
          white-space: normal;
        }
      }
      .home-expert-keyword {
        margin: 20px 0;
        display: flex;
        overflow: hidden;
        flex: 2;
        .el-tag {
          margin-bottom: 5px;
          background: #76877d;
          margin-right: 5px;
          border-radius: 5px;
          color: white;
        }
      }
      .home-expert-resource {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        .expert-resource {
          margin-right: 10px;
          margin-top: 10px;
          text-align: center;
        }
        img {
          width: 20px;
          height: 20px;
        }
      }
    }
    @media screen and (max-width: 576px) {
      .home-expert {
        width: 98%;
      }
    }
    @media screen and (min-width: 576px) {
      .home-expert {
        width: 48%;
      }
    }
  }
  .mobile-title {
    text-align: center;
    margin: 20px 0;
    font-size: 18px;
    font-weight: 700;
  }
}
</style>



// WEBPACK FOOTER //
// src/mobile/Home.vue